import React, { useState, useEffect } from 'react';
import { Button, CompositeView, GridView, OptionProps, SimpleView, useRouter } from '@digital/ui';
import TabelaOrdemCompra from './TabelaOrdemCompra';
import {
  getAllOrdemCompraPorStatusCodigo,
  OrdemCompraResult,
  FitroOrdemCompraPorStatusCodigo,
  getAllCompradores,
  updateUsuarioCompradorOrdemCompra,
  UpdateUsuarioCompradorOrdemCompraForm,
  getAllOrdemCompraPorStatusCodigoWithParams,
  ExportarOrdemDeCompra,
  ExportarOrdemDeCompraWithParams,
} from '@app/api/sas/ordemCompra';
import { getLoggedId } from '@app/helpers';
import { getByUsuarioIdSasFornecedorOc } from '@app/api/sas/sasFornecedor';
import { hasPermissionPerfil } from '@app/helpers/permissions';
import { EGuidPerfilAcesso } from '@app/enums/EGuidPerfilAcesso';
import { Tooltip } from 'highcharts';
import { size } from 'lodash';
import { dateTimeFormat } from '@app/helpers/dateTimeFormats';


const RelatorioOrdemCompra = () => {
  const { history } = useRouter();

  const [listOisStatusDiferenteConcluido, setListOisStatusDiferenteConcluido] = useState<OrdemCompraResult[]>([]);
  const [listOisStatusConcluidoOuCancelado, setListOisStatusConcluidoOuCancelado] = useState<OrdemCompraResult[]>([]);
  const [listCompradores, setCompradores] = useState<OptionProps[]>([]);
  const [update, setUpdate] = useState(false);
  const [usuarioLogadoId] = useState<string>(getLoggedId() || '');

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(0);
  const [totalPage, setTotalPage] = useState(0);
  const [totalItems, setTotalItems] = useState(0);

  const [periodoInicio, setPeriodoInicio] = useState(null);
  const [periodoFim, setPeriodoFim] = useState(null);

  const onUpdate = () => {
    setUpdate(!update);
    updateListar();
  };

  useEffect(() => {
    updateListar();
  }, [history.location.pathname]);

  const updateListar = () => {
    const defaultPagination = { current: 1, pageSize: 10 };

    history.location.pathname === '/ordensCompra/2' && listarStatusCanceladosOuConcluidos(defaultPagination);
    history.location.pathname === '/ordensCompra/1' && listarOutrosStatus(defaultPagination);
  };

  const verificaGestor = (): boolean => {
    if (
      hasPermissionPerfil([EGuidPerfilAcesso.GestorTecnico]) &&
      !hasPermissionPerfil([EGuidPerfilAcesso.GerenteDeCompras])
    ) {
      return true;
    }
    return false;
  };

  useEffect(() => {
    getAllCompradores().then(data => {
      if (data) {
        setCompradores(data);
      }
    });
  }, []);

  const listarOutrosStatus = (
    pagination: { current?: number; pageSize?: number },
    filters?: Record<string, (string | number)[] | null>,
    sorter?: any,
  ) => {
    const { current = 1, pageSize = 10 } = pagination;

    const filtroBase = {
      codigos: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 14, 15, 16],
      consultaStatusConcluido: false,
      filtroGestor: verificaGestor(),
    };

    getAllOrdemCompraPorStatusCodigoWithParams(filtroBase, current, pageSize, filters, sorter).then(data => {
      if (data) {
        setListOisStatusDiferenteConcluido(data.items);
        setPageSize(data.pageSize);
        setTotalPage(data.totalPages);
        setTotalItems(data.totalItems);
      }
    });
  };

  useEffect(() => {
  if (periodoInicio && periodoFim) {
    listarStatusCanceladosOuConcluidos({
      current: currentPage,
      pageSize: pageSize
    });
  }
  }, [periodoInicio, periodoFim]);


  const listarStatusCanceladosOuConcluidos = (
    pagination: { current?: number; pageSize?: number },
    filters?: Record<string, (string | number)[] | null>,
    sorter?: any,
  ) => {
    const { current = 1, pageSize = 10 } = pagination;

    const filtroBase = {
      codigos: [12, 13],
      consultaStatusConcluido: true,
      filtroGestor: verificaGestor(),
      periodoInicio: periodoInicio,
      periodoFim: periodoFim,
    };

    getAllOrdemCompraPorStatusCodigoWithParams(filtroBase, current, pageSize, filters, sorter).then(data => {
      if (data) {
        setListOisStatusConcluidoOuCancelado(data.items);
        setPageSize(data.pageSize);
        setTotalPage(data.totalPages);
        setTotalItems(data.totalItems);
      }
    });
  };

  const hasUpdateUsuarioCompradorOrdemCompra = (ordemCompraId: string, usuarioCompradorId: string) => {
    updateUsuarioCompradorOrdemCompra({
      ordemCompraId: ordemCompraId,
      usuarioCompradorId: usuarioCompradorId,
    } as UpdateUsuarioCompradorOrdemCompraForm).then(data => {
      onUpdate();
    });
  };

  const [exportando, setExportando] = useState(false);

  const handleExportarOutrosStatus = async (   
    { filters, sorter }: { filters?: Record<string, (string | number)[] | null>; sorter?: any }
    ) => {
    try {
      
      const filtroBase = {
        codigos: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 14, 15, 16],
        consultaStatusConcluido: false,
        filtroGestor: verificaGestor(),
        size: totalItems,
      };

      setExportando(true);
      await ExportarOrdemDeCompraWithParams(filtroBase, filters, sorter);
    } finally {
      setExportando(false);
    }
  };

  const handleExportarStatusCanceladosOuConcluidoss = async ( 
     { filters, sorter }: { filters?: Record<string, (string | number)[] | null>; sorter?: any }
    ) => {
    try {
      const filtroBase = {
        codigos: [12, 13],
        consultaStatusConcluido: true,
        filtroGestor: verificaGestor(),
        size: totalItems,
      };
      setExportando(true);
      await ExportarOrdemDeCompraWithParams(filtroBase, filters, sorter);
    } finally {
      setExportando(false);
    }
  };

  return (
    <SimpleView>
      <CompositeView>
        <GridView icon="files-add_file" title="EM ANDAMENTO" noform id={'1'}>
          {listOisStatusDiferenteConcluido && (
            <TabelaOrdemCompra
              widgetTitle={'EM ANDAMENTO'}
              dataSource={listOisStatusDiferenteConcluido}
              resultaTabelaStatusConcluido={false}
              optionPropsCompradores={listCompradores}
              updateUsuarioCompradorOrdemCompra={hasUpdateUsuarioCompradorOrdemCompra}
              onUpdate={onUpdate}
              currentPage={currentPage}
              pageSize={pageSize}
              totalPage={totalPage}
              totalItems={totalItems}
              fetchData={listarOutrosStatus}
              exportando={exportando}
              handleExportar={handleExportarOutrosStatus}
            />
          )}
        </GridView>
        <GridView icon="files-add_file" title="CONCLUÍDOS/CANCELADOS" noform id={'2'}>
          <TabelaOrdemCompra
            widgetTitle={'CONCLUÍDOS/CANCELADOS'}
            dataSource={listOisStatusConcluidoOuCancelado}
            resultaTabelaStatusConcluido={true}
            optionPropsCompradores={listCompradores}
            updateUsuarioCompradorOrdemCompra={() => {}}
            //onUpdate={onUpdate}
            onUpdate={(filtros: FitroOrdemCompraPorStatusCodigo) => {
              setPeriodoInicio(filtros.periodoInicio);
              setPeriodoFim(filtros.periodoFim);
            }}
            currentPage={currentPage}
            pageSize={pageSize}
            totalPage={totalPage}
            totalItems={totalItems}
            fetchData={listarStatusCanceladosOuConcluidos}
            exportando={exportando}
            handleExportar={handleExportarStatusCanceladosOuConcluidoss}
          />
        </GridView>
      </CompositeView>
    </SimpleView>
  );
};
export default RelatorioOrdemCompra;
